import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/features/kids/components/KidsShell.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/features/kids/components/ProfileGate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/features/kids/components/Rewards.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SectionHead"] */ "/opt/build/repo/src/features/kids/components/ui.tsx");
